<div id="reportLevel" [@reportLevelAnimation]>
    <div class="reportLevelContainer">
      <div class="reportLevelChat">
        <img src="{{assetsRoute}}/picture/reportlevel/chat-items.png"  id="chatItem-dark-1" class="chatItem-dark-1" alt="" />
        <img src="{{assetsRoute}}/picture/reportlevel/chat-items.png"  id="chatItem-dark-2" class="chatItem-dark-2" alt="" />
        <img src="{{assetsRoute}}/picture/reportlevel/chat-items.png"  id="chatItem-dark-3" class="chatItem-dark-4" alt="" />
        <img src="{{assetsRoute}}/picture/reportlevel/chat-items.png"  id="chatItem-dark-4" class="chatItem-dark-3" alt="" />

        <img id="ready-default-icon" src="{{assetsRoute}}/picture/reportlevel/ready.png" class="ready-default" alt="" />
        <div id="reportLevelIconPic" >
          <img src="{{assetsRoute}}/picture/reportlevel/nicetryi.png"  *ngIf="reportLV ==1"  class="ready-level-icon" alt="" />
          <img src="{{assetsRoute}}/picture/reportlevel/keepgoingi.png"  *ngIf="reportLV ==2"  class="ready-level-icon" alt="" />
          <img src="{{assetsRoute}}/picture/reportlevel/welldonei.png"  *ngIf="reportLV ==3"  class="ready-level-icon" alt="" />
          <img src="{{assetsRoute}}/picture/reportlevel/perfecti.png"  *ngIf="reportLV ==4"  class="ready-level-icon" alt="" />

        </div>
        <img src="{{assetsRoute}}/picture/reportlevel/chat-items-light.png"  *ngIf="reportLV >=1"  id="chatItem-light-1" class="chatItem-light-1" alt="" />
        <img src="{{assetsRoute}}/picture/reportlevel/chat-items-light.png"  *ngIf="reportLV >=2"  id="chatItem-light-2" class="chatItem-light-2" alt="" />
        <img src="{{assetsRoute}}/picture/reportlevel/chat-items-light.png"  *ngIf="reportLV >=3"  id="chatItem-light-3" class="chatItem-light-4" alt="" />
        <img src="{{assetsRoute}}/picture/reportlevel/chat-items-light.png"  *ngIf="reportLV >=4"  id="chatItem-light-4" class="chatItem-light-3" alt="" />

      </div>

      <div class="reportLevelResult" id="reportLevelResult">
        <img src="{{assetsRoute}}/picture/reportlevel/Nicetry.png" *ngIf="reportLV ==1"  class="report-result-pic" alt="" />
        <img src="{{assetsRoute}}/picture/reportlevel/Keepgoing.png" *ngIf="reportLV ==2"  class="report-result-pic" alt="" />
        <img src="{{assetsRoute}}/picture/reportlevel/welldone.png" *ngIf="reportLV ==3"  class="report-result-pic-ld" alt="" />
        <img src="{{assetsRoute}}/picture/reportlevel/perfect.png" *ngIf="reportLV ==4"  class="report-result-pic-ld" alt="" />
      </div>

      <div class="reportLevelTxt " id="reportLevelTxt">
        {{report.description}}
      </div>

      <div id="surveyBtn" class="fontSize18" (click)="exitReportLevel()">
        查看报告
      </div>
    </div>

</div>



// WEBPACK FOOTER //
// ./src/app/report-level-explain/report-level-explain.component.html